// extracted by mini-css-extract-plugin
export default {"characterLimitRemaining":"TextArea_characterLimitRemaining__5IziD"};